module.exports = __webpack_public_path__ + "media/images/logo-admin-c61854c0afd98f5d0a8b098ebbdb28b3.svg";